import { useLocation } from 'react-router-dom';

import Container from '@src/components/commons/containerPage.common';
import LabTabs from '@src/components/commons/tabs.common';

import ITSystemItemNurse from './ITSystemNurse';
import Banks from './banks';
import CertificateItems from './certificateItems';
import CountryCode from './countryCode';
import ListingScope from './listingScope';
import MandatoryCertificateItems from './mandatoryCertificateItems';
import Preferences from './preferences';
import ResidenStatus from './residenStatus';
import ScopeOfPractices from './scopeOfPractice';
import SkillsItemNurse from './skillNurse';

export default function MasterData() {
  const path = useLocation().pathname;
  const categories = [
    {
      idx: 0,
      title: 'Country',
      component: (
        <div className='px-6'>
          <CountryCode />
        </div>
      ),
    },
    {
      idx: 1,
      title: 'Residential',
      component: (
        <div className='px-6'>
          <ResidenStatus />
        </div>
      ),
    },
    {
      idx: 2,
      title: 'Preference',
      component: (
        <div className='px-6'>
          <Preferences />
        </div>
      ),
    },
    {
      idx: 3,
      title: 'Listing Scope',
      component: (
        <div className='px-6'>
          <ListingScope />
        </div>
      ),
    },
    {
      idx: 4,
      title: 'Cert Item',
      component: (
        <div className='px-6'>
          <CertificateItems />
        </div>
      ),
    },
    {
      idx: 5,
      title: 'Mandatory Cert Item',
      component: (
        <div className='px-6'>
          <MandatoryCertificateItems />
        </div>
      ),
    },
    {
      idx: 6,
      title: 'Skill',
      component: (
        <div className='px-6'>
          <SkillsItemNurse />
        </div>
      ),
    },
    {
      idx: 7,
      title: 'IT System',
      component: (
        <div className='px-6'>
          <ITSystemItemNurse />
        </div>
      ),
    },
    {
      idx: 8,
      title: 'Scope of Practices',
      component: (
        <div className='px-6'>
          <ScopeOfPractices />
        </div>
      ),
    },
    {
      idx: 9,
      title: 'Bank',
      component: (
        <div className='px-6'>
          <Banks />
        </div>
      ),
    },
  ];
  return (
    <Container pathUrl={path}>
      <div className='py-8'>
        <LabTabs menus={categories} />
      </div>
    </Container>
  );
}
